<template>
  <section class="mb-2">
    <div class="d-flex flex-wrap">
      <component
        class="mr-1"
        v-for="(filterComponent, index) in filterComponents"
        :is="component(filterComponent)"
        :key="index"
        :id="index"
        :label="filterComponent.label"
        :value="getValue(index)"
        :attributes="filterComponent.attributes"
        :options="filterComponent.options"
        :name="filterComponent.name"
        @keypress.enter.native="applyFilters"
        @filter-change="filterChange"
      ></component>
    </div>
    <button
      v-if="!autoApply"
      @click="applyFilters"
      type="button"
      class="btn btn-primary"
    >
      Filter anwenden
    </button>
  </section>
</template>

<script lang="babel">
import { unionWith } from "lodash";

import TakeFilter from "@/components/filters/TakeFilter";
import WhereFilter from "@/components/filters/WhereFilter";
import WhereLikeFilter from "@/components/filters/WhereLikeFilter";
import DateRangeFilter from "@/components/filters/DateRangeFilter";
import DateTimeRangeFilter from "@/components/filters/DateTimeRangeFilter";
import InOutFilter from "@/components/filters/InOutFilter";
import InOutPerformanceFilter from "@/components/filters/InOutPerformanceFilter";
import CheckboxFilter from "@/components/filters/CheckboxFilter";
import CheckboxValueFilter from "@/components/filters/CheckboxValueFilter";
import DateFilter from "@/components/filters/DateFilter";
import SelectFilter from "@/components/filters/SelectFilter";
import DropdownFilter from "@/components/filters/DropdownFilter";
import RoleFilter from "@/components/filters/RoleFilter";
import PermissionFilter from "@/components/filters/PermissionFilter";

export default {
  components: {
    TakeFilter,
    DateRangeFilter,
    DateTimeRangeFilter,
    WhereFilter,
    WhereLikeFilter,
    CheckboxFilter,
    CheckboxValueFilter,
    DateFilter,
    SelectFilter,
    InOutFilter,
    InOutPerformanceFilter,
    DropdownFilter,
    RoleFilter,
    PermissionFilter
  },
  created () {
    this.setupInternalFilters();
  },
  data() {
    return {
      internalFilters: []
    };
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    filterComponents: {
      required: true,
      type: Array
    },
    autoApply: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    setupInternalFilters() {
      this.internalFilters = this.value;
    },
    applyFilters() {
      this.$emit('input', this.internalFilters);
      this.$nextTick(() => {
        this.$emit('apply-filters');
      });
    },
    filterChange(changedFilter) {
      if (!changedFilter.value && !changedFilter.attributes) {
        // Remove filter if value/attributes is not set
        let internalFilterIndex = this.internalFilters.findIndex(internalFilter => internalFilter.id === changedFilter.id);

        if (internalFilterIndex >= 0) {
          this.internalFilters.splice(internalFilterIndex, 1);
        }
      } else {
        // Replace/add filter if value is set
        this.internalFilters = unionWith(
          [changedFilter],
          this.internalFilters,
          (a, b) => {
            // If no id, its a filter without a component, so just add it
            if (a.id === null || a.id === undefined) {
              return false;
            }

            return a.id === b.id;
          }
        );
      }

      if (this.autoApply) {
        this.applyFilters();
      }
    },
    component({ type }) {
        return Object.keys(this.$options.components).includes(type) ?
          type : null;
    },
    getValue(id) {
      let internalFilter = this.internalFilters.find(internalFilter => internalFilter.id === id);

      if (internalFilter) {
        if (internalFilter.attributes && ! internalFilter.value) {
          return internalFilter.attributes;
        }

        return internalFilter.value;
      } else {
        return undefined;
      }
    }
  },
  watch: {
    value() {
      this.setupInternalFilters();
    }
  }
};
</script>
